exports = module.exports = require("../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lsa-audit-left-part{padding-right:10px}.lsa-audit-left-part,.lsa-audit-right-part{float:left;width:calc(50% - 60px)}.lsa-audit-button{float:right}#rg_map_lsa_audit{font-size:12px;border-radius:5px!important;height:57px;background:#efefef!important;border:0}@media screen and (max-width:500px){.lsa-audit-left-part{padding-right:0;margin-bottom:10px}.lsa-audit-left-part,.lsa-audit-right-part{float:none;width:100%}.lsa-audit-button{float:none}}", ""]);

// exports
